import { API_URLS } from "../../../../utils/api-constants";
import { useGet } from "../../hooks";

export function useClientsData() {
  const getClients = useGet([API_URLS.CLIENTS]);

  return {
    isLoading: getClients.isLoading,
    isError: getClients.isError,
    data: getClients.data || [],
  };
}
